import dkAxios from '@/jslib/dk-axios'

export const getUserList = data => dkAxios({
  url: '/v1/cms/User',
  method: 'GET',
  params: data,
});

export const getUserDetail = data => dkAxios({
  url: `/v1/cms/User/${data}`,
  method: 'GET',
})

export const getUserPointDeal = data => dkAxios({
  url: '/v1/cms/User/pointDeal',
  method: 'POST',
  params: data,
})

export const bandUser = data => dkAxios({
  url: `/v1/cms/User/${data.uuid}`,
  method: 'PUT',
  data,
})

export const getUserOrderList = data => dkAxios({
  url: '/v1/cms/User/OrderList',
  method: 'POST',
  params: data,
})

export const changePoint = data => dkAxios({
  url: '/v1/cms/User/setPoint',
  method: 'POST',
  data,
})

export const addSupplier = data => dkAxios({
  url: '/v1/cms/User/addSupplier',
  method: 'POST',
  data,
})



// WEBPACK FOOTER //
// ./src/api/user.js